import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationPanelService {
  private isNotificationPanelActiveSubject = new BehaviorSubject<boolean>(false);
  public isNotificationPanelActive$: Observable<boolean> = this.isNotificationPanelActiveSubject.asObservable();

  private closeNotificationPanelSubject = new BehaviorSubject<boolean>(false);
  public closeNotificationPanel$: Observable<boolean> = this.closeNotificationPanelSubject.asObservable();

  /**
   * Opens the notification panel
   */
  openNotificationPanel(): void {
    this.isNotificationPanelActiveSubject.next(true);
  }

  /**
   * Closes the notification panel - can be called from anywhere in the application
   */
  closeNotificationPanel(): void {
    this.isNotificationPanelActiveSubject.next(false);
    this.closeNotificationPanelSubject.next(true);
  }

  /**
   * Gets the current notification panel state
   * @returns boolean indicating if panel is open
   */
  getNotificationPanelState(): boolean {
    return this.isNotificationPanelActiveSubject.value;
  }

  /**
   * Toggles the notification panel state
   */
  toggleNotificationPanel(): void {
    const currentState = this.isNotificationPanelActiveSubject.value;
    if (currentState) {
      this.closeNotificationPanel();
    } else {
      this.openNotificationPanel();
    }
  }
}